import { generateNoReadingsMessage } from '../blurbs';

import type { IUseNoReadingsProps, INoReadingsValues } from '../types';

export const useNoReadings = ({
  closeModal,
  handleSubmit,
  whichPerson,
  otherPerson,
}: IUseNoReadingsProps) => {
  const initialValues: INoReadingsValues = {
    usedDevice: [],
    lastUseDuration: null,
    reasonForStop: [],
    realTimeReading: null,
    isNormalLimits: null,
    repeatReading: '',
    importanceBloodPressure: [],
    raiseBloodPressure: [],
    lowerBloodPressure: [],
    importanceWeight: [],
    importanceBloodSugar: [],
    raiseBloodSugar: [],
    lowerBloodSugar: [],
    importanceOxygen: [],
    additionalDetailsMain: '',
    whichPerson,
    otherPerson,
  };

  const preparedData = (data: INoReadingsValues) => {
    const formData = Object.fromEntries(
      Object.entries(data).filter(([_, value]) => value !== null),
    );

    return {
      usedDevice: formData.usedDevice,
      lastUseDuration: formData.lastUseDuration,
      reasonForStop: formData.reasonForStop,
      realTimeReading: formData.realTimeReading,
      isNormalLimits: formData.isNormalLimits,
      repeatReading: formData.repeatReading,
      importanceBloodPressure: formData.importanceBloodPressure,
      raiseBloodPressure: formData.raiseBloodPressure,
      lowerBloodPressure: formData.lowerBloodPressure,
      importanceWeight: formData.importanceWeight,
      importanceBloodSugar: formData.importanceBloodSugar,
      raiseBloodSugar: formData.raiseBloodSugar,
      lowerBloodSugar: formData.lowerBloodSugar,
      importanceOxygen: formData.importanceOxygen,
      additionalDetailsMain: formData.additionalDetailsMain,
      whichPerson: formData.whichPerson,
      otherPerson: formData.otherPerson,
    };
  };

  const onSaveForm = (formData: INoReadingsValues) => {
    const preparedValues = preparedData(formData);

    const filteredValues = Object.fromEntries(
      Object.entries(preparedValues).filter(([_, value]) => value !== null),
    ) as INoReadingsValues;

    const message = generateNoReadingsMessage(filteredValues);

    handleSubmit(message);
    closeModal();
  };

  return {
    initialValues,
    onSaveForm,
  };
};
